/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React, { useContext } from "react";
import { environment } from "../../../../Basis/environment";
import { countries } from "../../../../Basis/Internationalisierung/languages";
import LaenderClient from "../../LaenderClient";
import Land from "../../Land";
import ILaenderContext from "./ILaenderContext";

export interface LaenderContextProps {
    children: React.ReactNode;
}

const laenderContext = React.createContext({} as ILaenderContext);

export default function LaenderContext(props: LaenderContextProps) {
    const [sortierteLaender, setSortierteLaender] = React.useState<Land[]>([])
    const client = new LaenderClient();
    const kannLaenderLaden = environment.mandant && !environment.isSystem;

    React.useEffect(() => {
        if (kannLaenderLaden) {
            client.ermittleLaender().then(laender => {
                laender.sort((land1, land2) => land1.iso.toUpperCase() === countries.de ? -1 : land1.bezeichnung.localeCompare(land2.bezeichnung));
                setSortierteLaender(laender);
            })
        }
    }, [kannLaenderLaden]);

    function istEuropaeischesAusland(landIso?: string): boolean {
        if (landIso === undefined || landIso === null || landIso === "") {
            return false;
        }

        const idx = sortierteLaender.findIndex(land => land.iso.localeCompare( landIso ?? "", undefined, { sensitivity: "accent" }) === 0);
        if (idx === -1) {
            console.warn(`Das Land mit dem Code '${landIso}' ist nicht auf der Länderliste`);
            return false;
        }

        return sortierteLaender[idx].istEuropaeischesAusland;
    }

    return (
        <laenderContext.Provider value={{ laender: sortierteLaender, istEuropaeischesAusland }}>
            {props.children}
        </laenderContext.Provider>
    );
}

export function useLaenderContext(): ILaenderContext {
    return useContext(laenderContext);
}
